import { useState } from "react";
import { Button, Form, FormControl, InputGroup } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { toast } from "react-toastify";

const AddPropertyByCode = ({
  onAdd,
  placeholder = "Dodavanje po šifri",
  successMessage = "Uspešno dodata preporuka",
  errorMessage = "Neuspešno dodata preporuka",
}) => {
  const [code, setCode] = useState("");

  const handleSubmit = () => {
    if (!code) return;

    onAdd(code)
      .then(() => {
        toast.success(successMessage);
        setCode("");
      })
      .catch((err) => {
        const backendMessage = err.response?.data?.message;
        toast.error(backendMessage || errorMessage);
      });
  };

  const handleChange = (e) => {
    setCode(e.target.value);
  };

  return (
    <Row className="mt-4">
      <Col lg={3} md={6}>
        <Form>
          <InputGroup className="mb-3">
            <FormControl
              placeholder={placeholder}
              aria-label={placeholder}
              aria-describedby="add-property-btn"
              onChange={handleChange}
              value={code}
            />
            <Button
              variant="outline-primary"
              id="add-property-btn"
              onClick={handleSubmit}
            >
              Dodaj
            </Button>
          </InputGroup>
        </Form>
      </Col>
    </Row>
  );
};

export default AddPropertyByCode;
